import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import HomeTopPlaces from "../../components/TopPlaces/HomeTopPlaces";
// import Stepper from 'react-stepper-horizontal/lib/Stepper';
// import { Stepper } from "@zendeskgarden/react-accordions";
import WizardStep1 from "./WizardStep1";
import WizardStep2 from "./WizardStep2";
import WizardStep3 from "./WizardStep3";
import location from "../../assets/plan_your_trip.png";
import { useNavigate } from "react-router-dom";
import "./PlanYourTrip.scss";
import { createRoute } from "../../services/myRoute.service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { FaCheck } from "react-icons/fa6";

function PlanYourTrip({ isUserLoggedIn }) {
  const [activeStep, setActiveStep] = useState(0);
  const [startPointName, setStartPointName] = useState(null);
  const [endPointName, setEndPointName] = useState(null);
  const [wizardData, setWizardData] = useState({
    routeName: "",
    routeStartingDate: "",
    startingPoint: "",
    endingPoint: "",
  });

  const IdentityId = useSelector((state) => {
    return state?.userDetailReducer?.userData;
  });
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  const nextPage = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const previousPage = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isUserLoggedIn) {
      try {
        const response = await createRoute(
          {
            RouteName: wizardData?.routeName?.replace(/\s*$/, ""),
            RouteStartingDate: wizardData?.routeStartingDate,
            userRouteDetail: [
              {
                mkmID: startPointName?.id,
                orderNumber: 0,
                visited: false,
              },
              {
                mkmID: endPointName?.id,
                orderNumber: 1,
                visited: false,
              },
            ],
          },
          {
            userName: IdentityId?.userName,
          }
        );
        if (
          response &&
          response?.status === 200 &&
          response?.data?.error === false
        ) {
          setActiveStep("done");
          toast.success("Your Route is added successfully!!!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setTimeout(() => {
            navigate("/my-routes");
          }, 1000);

          setWizardData({});
          setStartPointName();
          setEndPointName();
        } else if (response?.data?.error === true) {
          toast.error(`${response?.data?.errorDescription}`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
      } catch (err) {
        let error_message = "Oops.. something went wrong, try again !!!";
        if (
          err?.response &&
          err?.response?.data &&
          err?.response?.data?.message
        ) {
          error_message = err?.response?.data?.message;
        }
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add a new route ?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  return (
    <div className="main_section">
      <HomeTopPlaces />
      <div>
        {/* <SearchBar /> */}
        {/* <div className="breadcrumb_section">
          <Container>
            <Breadcrumb className="breadcrumb">
              <BreadcrumbItem>
                <Link to="/" className="breadcrumb_item1">
                  Home
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <Link to="#" className="breadcrumb_item2">
                  Plan Your Trip
                </Link>
              </BreadcrumbItem>
            </Breadcrumb>
          </Container>
        </div> */}
        <div className="plan_your_trip_section">
          <Container fluid>
            <div className="plan_your_trip_box">
              <div className="Wizard_block">
                {/* <Stepper
                  isHorizontal
                  activeIndex={activeStep}
                  className="stepper"
                >
                  <Stepper.Step
                    key="step-1"
                    className={
                      activeStep > 0 || activeStep === "done"
                        ? "step completed"
                        : activeStep === 0
                        ? "step active_step"
                        : "step"
                    }
                  >
                    <Stepper.Label
                      className={`sp_inner ${
                        activeStep === 0 ? "label_active" : ""
                      }`}
                    >
                      Name Route
                    </Stepper.Label>
                  </Stepper.Step>

                  <Stepper.Step
                    key="step-2"
                    className={
                      activeStep === 2 || activeStep === "done"
                        ? "step completed"
                        : activeStep === 1
                        ? "step active_step"
                        : "step"
                    }
                  >
                    <Stepper.Label
                      className={`sp_inner ${
                        activeStep === 1 ? "label_active" : ""
                      }`}
                    >
                      Trip Details
                    </Stepper.Label>
                  </Stepper.Step>

                  <Stepper.Step
                    key="step-3"
                    className={
                      activeStep === 2
                        ? "step active_step"
                        : activeStep === "done"
                        ? "step completed"
                        : "step"
                    }
                  >
                    <Stepper.Label
                      className={`sp_inner ${
                        activeStep === 2 ? "label_active" : ""
                      }`}
                    >
                      Summary
                    </Stepper.Label>
                  </Stepper.Step>
                </Stepper> */}

                <div className="nt-stepper">
                  {/* Step 1 */}
                  <div
                    className={`nt-step-box ${
                      activeStep === 0
                        ? "nt-active"
                        : activeStep > 0
                        ? "nt-completed"
                        : ""
                    }`}
                    style={
                      activeStep === 1 || activeStep === 2
                        ? {
                            borderRadius: "0px",
                            borderTopLeftRadius: "35px",
                            borderBottomLeftRadius: "35px",
                          }
                        : {}
                    }
                  >
                    <div className="nt-step-content">
                      <div className="nt-step-number">
                        {activeStep > 0 ? <FaCheck size={15} /> : "1"}
                      </div>
                      <div className="nt-step-label">Name Route</div>
                    </div>
                  </div>

                  {/* Step 2 */}
                  <div
                    className={`nt-step-box ${
                      activeStep === 1
                        ? "nt-active"
                        : activeStep > 1
                        ? "nt-completed"
                        : ""
                    }`}
                    style={
                      activeStep === 1
                        ? {
                            borderRadius: "0",
                            borderTopRightRadius: "35px",
                            borderBottomRightRadius: "35px",
                          }
                        : activeStep === 2
                        ? {
                            borderRadius: "0",
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px",
                          }
                        : {}
                    }
                  >
                    <div className="nt-step-content">
                      <div className="nt-step-number">
                        {activeStep > 1 ? <FaCheck /> : "2"}
                      </div>
                      <div className="nt-step-label">Start Point</div>
                    </div>
                  </div>

                  {/* Step 3 */}
                  <div
                    className={`nt-step-box ${
                      activeStep === 2 ? "nt-active" : ""
                    }`}
                    style={
                      activeStep === 2
                        ? {
                            borderRadius: "0",
                            borderTopRightRadius: "35px",
                            borderBottomRightRadius: "35px",
                          }
                        : {}
                    }
                  >
                    <div className="nt-step-content">
                      <div className="nt-step-number">3</div>
                      <div className="nt-step-label">Summary</div>
                    </div>
                  </div>
                </div>

                <div className="nt-step1_form">
                  <div className="nt-step_form">
                    {activeStep === 0 && (
                      <WizardStep1
                        nextPage={nextPage}
                        wizardData={wizardData}
                        setWizardData={setWizardData}
                      />
                    )}
                    {activeStep === 1 && (
                      <WizardStep2
                        nextPage={nextPage}
                        wizardData={wizardData}
                        setWizardData={setWizardData}
                        previousPage={previousPage}
                        startPointName={startPointName}
                        setStartPointName={setStartPointName}
                      />
                    )}
                    {activeStep === 2 || activeStep === "done" ? (
                      <WizardStep3
                        previousPage={previousPage}
                        setWizardData={setWizardData}
                        wizardData={wizardData}
                        endPointName={endPointName}
                        setEndPointName={setEndPointName}
                        handleSubmit={handleSubmit}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="location_img">
                    <img
                      src={location}
                      alt="map"
                      style={{ paddingTop: activeStep === 1 ? "40px" : "0px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
}

export default PlanYourTrip;
